@if (navigateBack) {
  <section class="mt-3 ms-2 mb-2">
    <nav>
      <a routerLink="../overview" class="text-uppercase fw-bold mx-auto mt-3 p-0 ms-1 mb-2">
        <i class="fa fa-chevron-left" aria-hidden="true"></i> Back to Overview Page
      </a>
    </nav>
  </section>
}
@if (isHighlightsPortal !== null) {
  <div
    id="noLicense"
    class="d-flex flex-nowrap justify-content-center align-content-center fullContentContainer h-100 m-0 no-licenses">
    <ng-container [ngTemplateOutlet]="isHighlightsPortal ? highlightsPortalContent : zbPortalContent"></ng-container>
  </div>
}
<ng-template #highlightsPortalContent>
  <section class="col px-5 d-flex flex-column justify-content-center align-items-center">
    <header class="mb-2">
      <h1 id="pageTitle"><strong>SUBSCRIPTION EXPIRED</strong></h1>
    </header>
    <p class="fw-normal">Your subscription has expired because you do not have any available licenses.</p>
    <p class="fw-normal">Reorder licenses to renew your subscription.</p>
    <ul class="custom-bullets ps-0">
      <li class="red-bullet-list-item fw-normal">
        Order online at <a href="https://earlylearning.highlights.com">earlylearning.highlights.com</a>
      </li>
    </ul>
  </section>
</ng-template>
<ng-template #zbPortalContent>
  <section class="col px-5 d-flex flex-column justify-content-center align-items-center">
    <header class="mb-2">
      <h1 id="pageTitle"><strong>SUBSCRIPTION EXPIRED</strong></h1>
    </header>
    <p class="fw-normal">Your subscription has expired because you do not have any available licenses.</p>
    <p class="fw-normal">Reorder materials and/or license to renew your subscription.</p>
    <ul class="custom-bullets ms-3">
      <li class="red-bullet-list-item fw-normal">
        Order online at <a href="https://shop.zaner-bloser.com">shop.zaner-bloser.com</a>
      </li>
      <li class="red-bullet-list-item fw-normal">
        Speak with a Customer Experience Specialist at <a class="text-primary" href="tel:8004213018" aria-label="8 0 0. 4 2 1. 3 0 1 8">(800) 421-3018</a>
      </li>
      <li class="red-bullet-list-item fw-normal">
        Email us at <a href="mailto:customerexperience@zaner-bloser.com">customerexperience&#64;zaner-bloser.com</a>
      </li>
      <li class="red-bullet-list-item fw-normal">
        Fax in your Purchase Order at <a href="fax:8009926087" aria-label="8 0 0. 9 9 2. 6 0 8 7">(800) 992-6087</a>
      </li>
      <li class="red-bullet-list-item fw-normal">
        Work with your area's <a href="https://www.zaner-bloser.com/contact/find-your-rep.php">sales representative</a>
      </li>
    </ul>
  </section>
</ng-template>